import type { ReactNode } from "react";
import { SiteFooter, SiteHeader } from "../../../SiteChrome";
import { accountApi } from "../api";

export function AccountShell({
  children,
  signedIn = false,
  accountType = window.location.pathname.startsWith("/organisaatio")
    ? "organization"
    : "consumer",
  workspaceUserLabel,
  workspace = false,
}: {
  children: ReactNode;
  signedIn?: boolean;
  accountType?: "consumer" | "organization";
  workspaceUserLabel?: string;
  workspace?: boolean;
}) {
  const logout = async () => {
    await accountApi("/api/account/logout", { method: "POST" }).catch(
      () => undefined,
    );
    window.location.assign("/");
  };

  return (
    <div className={`account-app${workspace ? " workspace-account-app" : ""}`}>
      <SiteHeader
        signedIn={signedIn}
        loginLabel={accountType === "organization" ? "Kirjaudu sisään" : "Kirjaudu"}
        onLogout={logout}
        workspaceUserLabel={workspaceUserLabel}
        workspace={workspace}
      />
      {children}
      <SiteFooter />
    </div>
  );
}
